import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { NmbLookup } from '../../shared/models/nmb-lookup';
import { environment } from '../../../environments/environment';

@Injectable({
    providedIn: 'root',
})
export class NmbServiceService {

    private apiUrl = environment.apiUrl;

    constructor(private http: HttpClient) {}
    getStatus(checkoutId: string, currencyCode: string): Observable<NmbLookup> {
        return this.http.get<NmbLookup>(
            `${this.apiUrl}/api/public/payments/nmb-payment-look-up?checkoutId=${checkoutId}&currencyCode=${currencyCode}`
        );
    }
}
